import { categories } from "@/mocks/site";

export type SortKey = "heat" | "latest";

type TopicsToolbarProps = {
  query: string;
  onQueryChange: (value: string) => void;
  category: string;
  onCategoryChange: (value: string) => void;
  sort: SortKey;
  onSortChange: (value: SortKey) => void;
  resultCount: number;
  categoryCounts: Record<string, number>;
};

export default function TopicsToolbar({
  query,
  onQueryChange,
  category,
  onCategoryChange,
  sort,
  onSortChange,
  resultCount,
  categoryCounts,
}: TopicsToolbarProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <label className="relative flex w-full items-center md:max-w-sm">
          <span className="pointer-events-none absolute left-3 flex h-5 w-5 items-center justify-center text-base text-foreground-400">
            <i className="ri-search-line" aria-hidden="true"></i>
          </span>
          <input
            type="search"
            value={query}
            onChange={(event) => onQueryChange(event.target.value)}
            placeholder="搜索事件、关键词或分类"
            aria-label="搜索事件"
            className="w-full rounded-md border border-background-300 bg-background-50 py-2.5 pl-10 pr-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
          />
        </label>

        <div className="flex flex-wrap items-center gap-3">
          <span className="flex items-center gap-1.5 whitespace-nowrap text-xs text-foreground-500">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-filter-3-line" aria-hidden="true"></i>
            </span>
            共 {resultCount} 篇
          </span>
          <div className="flex items-center gap-1 rounded-full border border-background-300 p-1">
            <button
              type="button"
              onClick={() => onSortChange("heat")}
              aria-pressed={sort === "heat"}
              className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium transition-colors ${
                sort === "heat"
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:bg-background-100"
              }`}
            >
              按热度
            </button>
            <button
              type="button"
              onClick={() => onSortChange("latest")}
              aria-pressed={sort === "latest"}
              className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium transition-colors ${
                sort === "latest"
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:bg-background-100"
              }`}
            >
              按最新
            </button>
          </div>
        </div>
      </div>

      <div className="mt-4 flex flex-wrap gap-2 border-t border-background-200 pt-4">
        {categories.map((item) => {
          const active = category === item.key;
          const count =
            item.key === "全部" ? categoryCounts.__all : categoryCounts[item.key] ?? 0;
          return (
            <button
              key={item.key}
              type="button"
              onClick={() => onCategoryChange(item.key)}
              aria-pressed={active}
              className={`cursor-pointer whitespace-nowrap rounded-full border px-3.5 py-1.5 text-xs font-medium transition-colors ${
                active
                  ? "border-secondary-500 bg-secondary-500 text-background-50"
                  : "border-background-300 text-foreground-600 hover:border-secondary-300 hover:bg-secondary-50"
              }`}
            >
              {item.label}
              <span className="ml-1.5 opacity-70">{count}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}